import { render, staticRenderFns } from "./CoachingCriteria.vue?vue&type=template&id=0872d44c&"
import script from "./CoachingCriteria.vue?vue&type=script&lang=js&"
export * from "./CoachingCriteria.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports